const noop = (...args) => {
};
export default noop;
//# sourceMappingURL=noop.js.map